import styled from 'styled-components';
import {
  Theme,
  AppBar,
  AppBarProps,
  MenuProps,
  Menu,
  Collapse,
  CollapseProps,
} from '@material-ui/core';
import { bookitColors } from 'styles/colors/bookitColors';
import transitions from '@material-ui/core/styles/transitions';

export const StyledTopBar = styled(
  ({
    theme,
    drawerWidth,
    sidePanelWidth,
    children,
    ...other
  }: {
    theme: Theme;
    drawerWidth: number;
    sidePanelWidth: number;
    children: React.ReactNode;
  } & AppBarProps) => <AppBar {...other}>{children}</AppBar>,
)`
  &.appBar {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    align-self: stretch;
    background-color: ${bookitColors.base.white};
    z-index: ${props => props.theme.zIndex.drawer + 1};
    transition: ${props =>
      props.theme.transitions.create(['width', 'margin'], {
        easing: props.theme.transitions.easing.sharp,
        duration: props.theme.transitions.duration.leavingScreen,
      })};
    border-bottom: 1px solid ${bookitColors.grayscale.grayBorders};
    width: calc(100% - ${60 + 1}px);
    &.appBarShift {
      margin-left: ${props => props.drawerWidth}px;
      width: calc(100% - ${props => props.drawerWidth}px);
      transition: ${props =>
        props.theme.transitions.create(['width', 'margin'], {
          easing: props.theme.transitions.easing.sharp,
          duration: props.theme.transitions.duration.enteringScreen,
        })};
    }
    &.sidePanelShift {
      margin-right: ${props => props.sidePanelWidth}px;
      width: calc(100% - ${props => 60 + 1 + props.sidePanelWidth}px);
      &.appBarShift {
        width: calc(
          100% - ${props => props.drawerWidth + props.sidePanelWidth}px
        );
      }
    }
  }
`;

export const CollapseBar = styled(
  ({
    theme,
    children,
    ...other
  }: {
    theme: Theme;
    children: React.ReactNode;
  } & CollapseProps) => <Collapse {...other}>{children}</Collapse>,
)`
  &.subBar {
    display: flex;
    height: 56px;
    padding: 4px 16px 4px 32px;
    align-items: center;
    gap: 24px;
    align-self: stretch;
    width: 100%;
    gap: ${props => props.theme.spacing(2)}px;
    border-top: 1px solid ${bookitColors.grayscale.grayBorders};
    background: ${bookitColors.primary.background};
    & .frame {
      display: flex;
      align-items: center;
      gap: 16px;
      flex: 1 0 0;
      & .controls {
        display: flex;
        align-items: center;
        gap: 8px;
        flex: 1 0 0;
      }
    }
  }
`;

export const SubTopBar = styled.div.attrs(props => ({ props }))<{
  theme: Theme;
}>`
  &.subBar {
    display: flex;
    height: 56px;
    padding: 4px 16px 4px 32px;
    align-items: center;
    gap: 24px;
    align-self: stretch;
    width: 100%;
    gap: ${props => props.theme.spacing(2)}px;
    border-top: 1px solid ${bookitColors.grayscale.grayBorders};
    background: ${bookitColors.primary.background};
    transition: ${transitions.create('height', {
      easing: transitions.easing.easeInOut,
      duration: 150,
    })};
    &.subBarCollapsed {
      height: 0;
      display: none;
    }
    & .frame {
      display: flex;
      align-items: center;
      gap: 16px;
      flex: 1 0 0;
      & .controls {
        display: flex;
        align-items: center;
        gap: 8px;
        flex: 1 0 0;
      }
    }
  }
`;
// box-shadow: 0px 1px 1px -1px rgb(0 0 0 / 20%),
// 0px 0px 2px 0px rgb(0 0 0 / 14%), 0px 1px 1px 0px rgb(0 0 0 / 12%);
export const ProfileSection = styled.div.attrs(props => ({ props }))<{
  theme: Theme;
}>`
  &.userProfile {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
  }
`;
// display: flex;
//     flex-direction: row;
//     align-items: center;
//     padding: 0px;
//     gap: ${props => props.theme.spacing(2)}px;
//     & span > a {
//       color: ${props => props.theme.palette.common.graySubtitle};
//       & > svg {
//         font-size: 20px;
//       }
//     }
//     @media (max-width: ${props => props.theme.breakpoints.values.md}px) {
//       gap: 12px;
//     }
//     & .mainMenu {
//       display: flex;
//       align-items: flex-start;
//       padding: 0px;
//       &.userMenu {
//         flex-direction: column;
//         flex: none;
//         order: 4;
//         flex-grow: 0;
//       }
//       &.menuIcon {
//         flex-direction: row;
//         flex: none;
//         flex-grow: 0;
//       }
//       &.menuCores {
//         flex-direction: row;
//         flex: none;
//         flex-grow: 0;
//         order: 1;
//         align-self: center;
//       }
//       &.menuSearch {
//         flex-direction: column;
//         flex: none;
//         flex-grow: 0;
//         order: 0;
//         align-self: stretch;
//       }
//     }
export const StyledUserMenu = styled(
  ({
    theme,
    children,
    ...other
  }: {
    theme: Theme;
    children: React.ReactNode;
  } & MenuProps) => <Menu {...other}>{children}</Menu>,
)`
  & li {
    & a {
      margin-left: ${props => props.theme.spacing(2)}px;
      color: ${props => props.theme.palette.text.primary};
    }
  }
`;
